import { SVGFC } from '@repo/toolkit/types'

const Share2Icon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.9164 20.957C14.0033 20.957 13.0894 20.179 12.2992 19.3888L11.2942 18.3846L9.47531 19.6394C8.9618 19.9934 8.28635 20.0122 7.7533 19.6931C7.22189 19.3741 6.92323 18.7679 6.99403 18.1485L7.4172 14.5068L4.6104 11.7C3.71197 10.8015 2.82899 9.7436 3.08778 8.70681C3.34738 7.67085 4.62424 7.15326 5.83925 6.78299L16.8915 3.41956C18.1049 3.05091 19.6031 2.73515 20.4348 3.56441C21.2657 4.39612 20.9483 5.89433 20.5796 7.10771L17.2162 18.16C16.8459 19.375 16.3283 20.6518 15.2924 20.9114C15.167 20.9423 15.0417 20.957 14.9164 20.957ZM11.3682 16.949C11.5293 16.949 11.6897 17.0109 11.8101 17.1321L13.183 18.505C14.328 19.6492 14.8082 19.7436 14.9888 19.6989C15.1719 19.6533 15.5487 19.3449 16.0199 17.7954L19.3833 6.74312C19.9017 5.03983 19.6731 4.57108 19.5502 4.44901C19.4289 4.32613 18.9561 4.09745 17.2561 4.61585L6.20382 7.97929C4.65434 8.45048 4.34591 8.82727 4.30034 9.01037C4.25476 9.19347 4.34916 9.67036 5.49419 10.8162L8.51502 13.837C8.65011 13.9721 8.71603 14.1617 8.69406 14.3514L8.23589 18.2926C8.22043 18.4236 8.28391 18.5538 8.39784 18.6214C8.51015 18.6897 8.655 18.6865 8.76568 18.6108L11.0134 17.0597C11.1208 16.9856 11.2445 16.949 11.3682 16.949Z"
        fill={color}
      />
      <path
        d="M8.07353 14.9045C7.89857 14.9045 7.7236 14.8313 7.5999 14.6881C7.37447 14.426 7.40378 14.0313 7.665 13.8059L13.8816 8.44457C14.1445 8.21996 14.5376 8.24763 14.7638 8.50967C14.9892 8.77171 14.9599 9.16641 14.6987 9.39183L8.48206 14.7532C8.36406 14.8549 8.21838 14.9045 8.07353 14.9045Z"
        fill={color}
      />
    </svg>
  )
}

export default Share2Icon
